import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import Box from '@zacousticrepo/grommet-v1-custom/components/Box';
import Headline from '@zacousticrepo/grommet-v1-custom/components/Headline';
import Heading from '@zacousticrepo/grommet-v1-custom/components/Heading';
import Paragraph from '@zacousticrepo/grommet-v1-custom/components/Paragraph';

import { pageLoaded } from '../utils';

class NotFound extends Component {
    componentDidMount() {
        pageLoaded('Not Found');
    }

    render() {
        return (
            <Box full={true} align="center" justify="center">
                <Headline strong={true}>404</Headline>
                <Heading>Oops...</Heading>
                <Paragraph size="large" align="center">
                    It seems that you are in the wrong route. Please check your URL and try again.
                </Paragraph>
            </Box>
        );
    }
}

NotFound.propTypes = {
    dispatch: PropTypes.func.isRequired
};

export default NotFound;
